import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { IJobBase } from '@/types'
import { sanitizeHtml, useStores } from '@/utils'
import { EditorContent } from '@/componentsV2/atoms/EditorContent'
import { JobCharacteristicItem } from '@/componentsV2/molecules/JobCharacteristicItem'
import { JobContentOverview } from '@/componentsV2/molecules/JobContentOverview'
import { JobApplyGroupBottom } from '@/componentsV2/molecules/JobApplyGroupBottom'
import { JobContentSidebar } from '@/componentsV2/organisms/JobContentSidebar'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
}

export const JobContent: FC<Props> = observer(({ job }) => {
  const { t } = useTranslation(['jobs-[job_slug]', 'jobs'])
  const { viewer } = useStores()
  const isCompanyMember = viewer.viewer?.isCompanyMember(job?.company.slug)

  return (
    <div className='container'>
      <div className={styles.container}>
        <div className={styles.body}>
          <JobCharacteristicItem name={t('募集要項')}>
            <JobContentOverview job={job} />
          </JobCharacteristicItem>
          <JobCharacteristicItem name={t('求人の内容')}>
            <EditorContent sanitizedHtml={sanitizeHtml(job?.body)} />
          </JobCharacteristicItem>
          <JobApplyGroupBottom job={job} />
          {isCompanyMember && <div className={styles.notice}>{t('会社のメンバーは応募できません。')}</div>}
        </div>
        <JobContentSidebar company={job?.company} />
      </div>
    </div>
  )
})
